import React from 'react';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons'

export default ({menuIsVisible, showMenu, menuItems}) => (
    menuIsVisible && (
        <div className="menu">
            <div className="menu__inner">
                <div className="close" onClick={() => showMenu(false)}>
                    <FontAwesomeIcon icon={faTimes}/>
                </div>
                <ul>
                    {menuItems.map((item, i) => (
                        <li  key={i} onClick={() => showMenu(false)}>
                            <Link to={item.get('link')}>
                                {item.get('label')}
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    )
)


// WEBPACK FOOTER //
// ./src/components/Menu.js